import styled from 'styled-components';

const CircleCheckboxWrapper = styled.div`
  box-sizing: border-box;
  border-width: 1px;
  border-style: ${({ checked }) => (checked ? 'none' : 'solid')};
  background-color: ${({ checked }) => (checked ? '#000000' : '#FFFFFF')};
  border-color: #999;
  border-radius: 50%;
  min-width: 12px;
  height: 12px;
  margin-top: 1px;
`;

export default CircleCheckboxWrapper;
